export default __webpack_public_path__ + "static/media/36k.1b145c03.md";